import React from 'react';
import { SpruceHelpInlineLink, Header3Text } from '../../../components';
export const ErrorTitle: React.FC<{}> = () => {
  return (
    <Header3Text>
      Property Address was not updated.
      <br /> Please <SpruceHelpInlineLink /> to submit a request for help
    </Header3Text>
  );
};
